import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/site/Layout";
import Home from "./pages/Home";
import FmService from "./pages/fm/FmService";
import { AREAS } from "./content/areas";

const About = lazy(() => import("./pages/About"));
const Commitment = lazy(() => import("./pages/Commitment"));
const Process = lazy(() => import("./pages/Process"));
const FaqPage = lazy(() => import("./pages/FaqPage"));
const Packages = lazy(() => import("./pages/Packages"));
const Emergency = lazy(() => import("./pages/Emergency"));
const Triage = lazy(() => import("./pages/Triage"));
const Report = lazy(() => import("./pages/Report"));
const FmOverview = lazy(() => import("./pages/fm/FmOverview"));
const OutOfHours = lazy(() => import("./pages/fm/OutOfHours"));
const NecosApp = lazy(() => import("./pages/fm/NecosApp"));
const AreasHub = lazy(() => import("./pages/fm/AreasHub"));
const CityPage = lazy(() => import("./pages/fm/CityPage"));
const Clients = lazy(() => import("./pages/Clients"));
const Contractors = lazy(() => import("./pages/Contractors"));
const ContractorApply = lazy(() => import("./pages/FormPages").then((m) => ({ default: m.ContractorApply })));
const ContractorUpdate = lazy(() => import("./pages/ContractorUpdate"));
const RequestCallout = lazy(() => import("./pages/FormPages").then((m) => ({ default: m.RequestCallout })));
const Contact = lazy(() => import("./pages/Contact"));
const Legal = lazy(() => import("./pages/Legal"));
const Downloads = lazy(() => import("./pages/Downloads"));
const LegacyOrNotFound = lazy(() => import("./pages/LegacyOrNotFound"));
const AdminLayout = lazy(() => import("./components/admin/AdminLayout").then((m) => ({ default: m.AdminLayout })));
const AdminInbox = lazy(() => import("./components/admin/AdminInbox"));
const AdminDetail = lazy(() => import("./components/admin/AdminDetail"));
const AdminSettings = lazy(() => import("./components/admin/AdminSettings"));
const AdminPostcodes = lazy(() => import("./components/admin/AdminPostcodes"));

const LEGAL = ["privacy", "social-responsibility", "modern-slavery", "cookies", "personal-data", "contractor-terms"];
const FM_SLUGS = ["reactive-maintenance", "emergency-make-safe", "planned-maintenance", "compliance", "cleaning", "voids-refurbishment", "property-maintenance", "sectors"];

function App() {
  return (
      <BrowserRouter>
        <Suspense fallback={null}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/commitment" element={<Commitment />} />
            <Route path="/about/process" element={<Process />} />
            <Route path="/about/faq" element={<FaqPage />} />
            <Route path="/about/packages" element={<Packages />} />
            <Route path="/emergency-call-out" element={<Emergency />} />
            <Route path="/emergency-call-out/triage" element={<Triage />} />
            <Route path="/report" element={<Report />} />
            <Route path="/facilities-management" element={<FmOverview />} />
            {FM_SLUGS.map((s) => (
              <Route key={s} path={`/facilities-management/${s}`} element={<FmService slug={s} />} />
            ))}
            <Route path="/facilities-management/out-of-hours" element={<OutOfHours />} />
            <Route path="/facilities-management/necos-app" element={<NecosApp />} />
            <Route path="/areas" element={<AreasHub />} />
            {AREAS.map((a) => (
              <Route key={a.slug} path={`/areas/${a.slug}`} element={<CityPage slug={a.slug} />} />
            ))}
            <Route path="/clients" element={<Clients />} />
            <Route path="/contractors" element={<Contractors />} />
            <Route path="/contractors/apply" element={<ContractorApply />} />
            <Route path="/contractors/update" element={<ContractorUpdate />} />
            <Route path="/request-callout" element={<RequestCallout />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/downloads" element={<Downloads />} />
            {LEGAL.map((s) => (
              <Route key={s} path={`/legal/${s}`} element={<Legal slug={s} />} />
            ))}
            <Route path="*" element={<LegacyOrNotFound />} />
          </Route>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminInbox />} />
            <Route path="submissions/:id" element={<AdminDetail />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="postcodes" element={<AdminPostcodes />} />
          </Route>
        </Routes>
        </Suspense>
      </BrowserRouter>
  );
}

export default App;
